// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__x+-LK","left":"footer_left__yeuWB","right":"footer_right__K9zkZ","icons":"footer_icons__KClkT","icon":"footer_icon__kVP+Z"};